module.exports = __webpack_public_path__ + "media/spin_the_wheel_win-957aadb74ed75594baace49459fe8256.mp3";